const React = require('react');
const BaseComponent = require('../shared/base');

class CartStepperFlow extends BaseComponent {

    render(){
        return(
            <div className="stepper-container">
                <ul className="stepper-progress-bar">
                    <li className="stepper-active">Información de la orden</li>
                    <li >Detalles del comprador</li>
                    <li >Pago</li>
                </ul>
            </div>
        );
    }

}
module.exports = CartStepperFlow;